import 'react-image-lightbox/style.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import './index.scss';
import {log} from 'scrumship-client';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import configureStore from './store';
import {Route, Router} from 'react-router-dom';
import {PersistGate} from 'redux-persist/es/integration/react';
import ThemeProvider from './containers/template/theme/ThemeProvider';
import AxiosSetup from './containers/template/AxiosSetup';
import IntlSetup from './common/IntlSetup';
import history from './history';

import EmbPage from './containers/embeddable/EmbPage';
import Spinner from './common/Spinner';
import PricingSheetPage from './containers/embeddable/pricing_sheet/PricingSheetPage';
import {WebSocketProvider} from './context/websocket';
import App from './containers/template/App';

log('EPEXOf8');

export const {persistor, store} = configureStore();

const target = document.querySelector('#root');

render(
    <Provider store={store}>
        <IntlSetup>
            <PersistGate
                loading={<Spinner />}
                persistor={persistor}>
                <WebSocketProvider>
                    <AxiosSetup />
                    <Router history={history}>
                        <App>
                            <ThemeProvider />
                            <Route exact path='/' component={EmbPage} />
                            <Route
                                path={['/slabs', '/lumbers', '/bundles', '/industrial_packs', '/industrial_packs_mass_timber']}
                                component={EmbPage} />
                            <Route exact path='/pricing_sheet' component={PricingSheetPage} />
                        </App>
                    </Router>
                </WebSocketProvider>
            </PersistGate>
        </IntlSetup>
    </Provider>,
    target,
);



// WEBPACK FOOTER //
// ./src/index.js